import { render, staticRenderFns } from "./ListTasks.vue?vue&type=template&id=6a410d9f&scoped=true&lang=pug&"
import script from "./ListTasks.vue?vue&type=script&lang=js&"
export * from "./ListTasks.vue?vue&type=script&lang=js&"
import style0 from "./ListTasks.vue?vue&type=style&index=0&id=6a410d9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a410d9f",
  null
  
)

export default component.exports